import "client-only"
import Cookies from "js-cookie"
import type { Consent } from "@/vendors/Cookiebot/consent"
import { getSessionData } from "./get-session-data"
import { mapToSessionCookie } from "./mappers/map-to-session-cookie"
import { mapToSessionData } from "./mappers/map-to-session-data"
import { shouldCreateNewSession } from "./should-create-new-session"

type SessionCookieHandlerParams = {
  readonly CookieConsent: Consent
}

export function sessionCookieHandler({
  CookieConsent,
}: SessionCookieHandlerParams): number | null {
  if (!CookieConsent.statistics || !CookieConsent.marketing) {
    return null
  }
  const existingSession = getSessionData()
  const now = Date.now()

  const isNewSession = shouldCreateNewSession(existingSession, now)
  const sessionData = mapToSessionData({
    existingSession,
    isNewSession,
    now,
  })
  const { cookieName, options, rawSessionCookieData } =
    mapToSessionCookie(sessionData)
  Cookies.set(cookieName, rawSessionCookieData, options)

  return sessionData.sessionCount
}
